<template>
  <CreateOffer />
</template>

<script>
import CreateOffer from './CreateOffer';
export default {
  components: {
    CreateOffer,
  },
};
</script>

<style lang="scss" scoped></style>
